import { logError } from 'setup/logger/logError';
import { getErrorMessage } from 'shared/utils/errorHandling';
import { frontendVersionWithBuildNumber } from 'shared/version';
import { getServiceWorkerRegistrationState } from '../diagnostics/getServiceWorkerRegistrationState';
import { getFailedStages } from './model';
import type { AlignmentAttempt } from './types';

/**
 * Reports that the worker could not be brought to the page's version, once,
 * after the recovery ended: what each try waited for (`stages`, in order),
 * how long it took, what the active worker reported, and the registration as
 * it stands. The lists are flat: Sentry cuts nested objects of an event.
 */
export async function reportServiceWorkerAlignmentFailure(attempts: AlignmentAttempt[]): Promise<void> {
  const failures = attempts.flatMap(({ failure }) => (failure ? [failure] : []));
  const lastFailure = failures.at(-1);
  logError('Service worker could not be aligned with the page', {
    pageVersion: frontendVersionWithBuildNumber,
    online: navigator.onLine,
    stages: getFailedStages(attempts),
    durationsMs: attempts.map(({ durationMs }) => durationMs),
    activeVersion: lastFailure?.activeVersion,
    errorMessage: lastFailure?.error === undefined ? undefined : getErrorMessage(lastFailure.error),
    registration: await getServiceWorkerRegistrationState().catch(() => undefined),
  });
}
